module.exports = __webpack_public_path__ + "static/media/team.3564fc06.jpg";